/* CYGNUSS 29/10/2026: campanha 11.11, prototipo da troca pela copia de preco fixo (pedido do Guifa: so teste).
   O checkout (CartPanda) cobra o preco do produto cadastrado nele, nao o desconto da Shopify. Por isso cada sutia da oferta tem uma
   copia "<handle>-11-11" com o preco da campanha. Com a quantidade da oferta (window.cyg1111Troca.qtd) ou mais de sutias no carrinho,
   cada linha de 1 unidade que tem copia vira a copia (mesma cor e tamanho, mesmas propriedades); abaixo disso, a copia volta ao
   original. O botao de finalizar espera a troca terminar. */
(function () {
  var cfg = window.cyg1111Troca;
  if (!cfg || !window.fetch) return;
  /* 30/10/2026: roda tambem no tema publicado, mas so com a campanha no ar (fase do relogio; na previa, a fase forcada) */
  if (!window.cyg1111 || !window.cyg1111.fase) return;

  var SUF = '-11-11';
  /* endereco da copia: o da lista (cfg.copias, original -> copia) ou o do original com -11-11 */
  var copias = cfg.copias || {};
  var originais = {};
  Object.keys(copias).forEach(function (o) { originais[copias[o]] = o; });
  function copiaDe(h) { return copias[h] || h + SUF; }
  function originalDe(h) { return originais[h] || (h.slice(-SUF.length) === SUF ? h.slice(0, -SUF.length) : h); }
  /* 31/10/2026 (Guifa): degrau de 2 pecas. Com 2 sutias da oferta, cada linha de 1 peca vira a copia de 2 pecas (cfg.copias2,
     original -> copia, preco fixo por peca cfg.preco2 nas duas plataformas); com a quantidade da oferta, a copia de sempre.
     preco2 vazio (Configuracoes do tema) desliga o degrau. */
  var copias2 = cfg.preco2 > 0 && cfg.qtd > 2 ? (cfg.copias2 || {}) : {};
  Object.keys(cfg.copias2 || {}).forEach(function (o) { originais[cfg.copias2[o]] = o; });
  function destinoDe(orig, total) {
    if (total >= cfg.qtd) return copiaDe(orig);
    if (total === 2 && copias2[orig]) return copias2[orig];
    return orig;
  }
  var mapas = {};
  var elegiveis = null;
  var ocupado = null;
  var de_novo = false;

  function json(u, o) { return fetch(u, o).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }

  /* pecas por linha: mesma leitura do tema para a cor do kit ("Preto | Nude" = 2, "2 Pretos | 1 Nude" = 3, "Preto - Bege" = 2) */
  function pecas(cor) {
    var v = String(cor || ''), partes;
    if (v.indexOf('|') >= 0) partes = v.split('|');
    else if (v.indexOf(' - ') >= 0 || v.indexOf(' / ') >= 0) partes = v.replace(/ \/ /g, ' - ').split(' - ');
    else { var n = parseInt(v, 10); return n > 0 ? n : 1; }
    return partes.reduce(function (s, p) { var n = parseInt(p, 10); return s + (n > 0 ? n : 1); }, 0);
  }

  function chave(v) { return [v.option1, v.option2, v.option3].filter(Boolean).join(' | '); }

  function produto(h) {
    if (!(h in mapas)) mapas[h] = json('/products/' + h + '.js').then(function (p) {
      var m = {};
      p.variants.forEach(function (v) { m[chave(v)] = v; });
      return m;
    }).catch(function () { return null; });
    return mapas[h];
  }

  function colecao() {
    if (!elegiveis) elegiveis = json('/collections/' + cfg.colecao + '/products.json?limit=250').then(function (d) {
      var s = {};
      d.products.forEach(function (p) { s[p.handle] = 1; });
      return s;
    }).catch(function () { return {}; });
    return elegiveis;
  }
  /* o Leve junto (assets/cart-upsell.js) le a mesma lista para tirar o sutia que esta fora da oferta */
  cfg.naOferta = colecao;

  function corDaLinha(i) { return (i.options_with_values && i.options_with_values[0] && i.options_with_values[0].value) || ''; }
  function ehCopia(i) { return i.handle.slice(-SUF.length) === SUF || i.handle in originais; }

  function avisar(cart) {
    var sec = cart.sections || undefined;
    if (sec) delete cart.sections;
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'cyg-1111-troca', data: { itemCount: cart.item_count, sections: sec } } }));
  }

  /* 30/10/2026 (Guifa: "demorou um pouco para trocar"): usa o carrinho que veio no evento quando ele vem inteiro, busca o original e a
     copia ao mesmo tempo (e ja deixa pre-carregados) e pede o HTML do carrinho junto da ultima chamada, sem outra ida a loja para redesenhar */
  var pecasNoCarrinho = 0;
  function secoes() {
    return [].map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (e) { return e.dataset.sectionId; });
  }
  function conferir(cartPronto) {
    if (ocupado) { de_novo = true; return ocupado; }
    var pega = cartPronto && cartPronto.items ? Promise.resolve(cartPronto) : json('/cart.js');
    ocupado = Promise.all([pega, colecao()]).then(function (r) {
      var cart = r[0], s = r[1];
      var linhas = cart.items.filter(function (i) { return s[i.handle] || ehCopia(i); });
      var total = linhas.reduce(function (t, i) { return t + pecas(corDaLinha(i)) * i.quantity; }, 0);
      pecasNoCarrinho = total;
      leveJunto();
      /* cada linha de 1 peca (ou copia) vai para o endereco do degrau: original, copia de 2 pecas ou copia da oferta */
      var trocar = linhas.filter(function (i) {
        if (pecas(corDaLinha(i)) !== 1 && !ehCopia(i)) return false;
        var orig = ehCopia(i) ? originalDe(i.handle) : i.handle;
        produto(i.handle); produto(orig); produto(copiaDe(orig)); if (copias2[orig]) produto(copias2[orig]);
        i.cygDestino = destinoDe(orig, total);
        return i.cygDestino !== i.handle;
      });
      return Promise.all(trocar.map(function (i) {
        var destino = i.cygDestino;
        return Promise.all([produto(i.handle), produto(destino)]).then(function (dp) {
          var de = dp[0], para = dp[1];
          var v = de && Object.keys(de).map(function (k) { return de[k]; }).find(function (x) { return x.id === i.variant_id; });
          var alvo = v && para && para[chave(v)];
          return alvo && alvo.available ? { linha: i, id: alvo.id } : null;
        });
      })).then(function (pares) {
        pares = pares.filter(Boolean);
        if (!pares.length) return null;
        var add = pares.map(function (p) { return { id: p.id, quantity: p.linha.quantity, properties: p.linha.properties || {} }; });
        var tirar = {};
        pares.forEach(function (p) { tirar[p.linha.key] = 0; });
        return json('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: add }) })
          .then(function () { return json('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: tirar, sections: secoes().join(',') }) }); })
          .then(avisar);
      });
    }).catch(function (e) { try { console.warn('[cyg-1111-troca]', e); } catch (x) {} }).then(function () {
      ocupado = null;
      if (de_novo) { de_novo = false; return conferir(); }
    });
    return ocupado;
  }

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'cyg-1111-troca') return;
    var c = e.detail && e.detail.resource;
    setTimeout(function () { conferir(c && c.items && typeof c.item_count === 'number' ? c : null); }, 0);
  });

  /* finalizar a compra so depois da troca: segura o clique, confere o carrinho e clica de novo */
  var liberado = false;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[name="checkout"], .cart__checkout-button, a[href="/checkout"]');
    if (!b || liberado) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    conferir().then(function () { liberado = true; b.click(); setTimeout(function () { liberado = false; }, 1000); });
  }, true);

  /* 30/10/2026 (pedido do Guifa): no "Leve junto" do carrinho, o sutia da oferta mostra o preco da campanha quando leva-lo completa
     a quantidade da oferta (o riscado e o preco dele de verdade). O preco do card continua o do tema; o da oferta entra por cima. */
  var precoOferta = (window.cyg1111.fase === 'dia' ? cfg.precoDia : cfg.precoEsquenta) || 0;
  function reais(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
  /* preco de 1 peca da copia de 2 pecas, lido do proprio produto (a mesma fonte do carrinho) */
  function precoDois(h) {
    if (!copias2[h]) return Promise.resolve(0);
    return produto(copias2[h]).then(function (m) {
      var v = m && Object.keys(m).map(function (k) { return m[k]; }).filter(function (x) { return x.available; })[0];
      return v ? v.price : 0;
    });
  }
  /* o preco que o sutia h teria ao entrar no carrinho agora: oferta, copia de 2 pecas ou 0 (sem degrau) */
  function precoAoEntrar(h, s) {
    if (!s[h]) return Promise.resolve(0);
    var n = pecasNoCarrinho + 1;
    if (n >= cfg.qtd) return Promise.resolve(precoOferta);
    if (n === 2) return precoDois(h);
    return Promise.resolve(0);
  }
  function leveJunto() {
    if (!precoOferta) return;
    colecao().then(function (s) {
      [].forEach.call(document.querySelectorAll('cart-upsell-component .cart-upsell-product-card'), function (card) {
        var b = card.querySelector('[data-product-handle]'), box = card.querySelector('[data-price-container]');
        if (!b || !box) return;
        precoAoEntrar(b.getAttribute('data-product-handle'), s).then(function (preco) {
          var atual = box.querySelector('[data-price-current]'), tag = box.querySelector('.c11-lj-preco');
          card.classList.toggle('c11-lj-on', !!preco);
          if (!preco) { if (tag) tag.remove(); return; }
          var de = (atual && atual.textContent || '').replace(/\s+/g, ' ').trim();
          var html = '<s aria-hidden="true">' + de + '</s><b aria-hidden="true">' + reais(preco) + '</b>';
          if (!tag) { tag = document.createElement('span'); tag.className = 'c11-lj-preco'; tag.setAttribute('role', 'text'); box.appendChild(tag); }
          if (tag.innerHTML !== html) { tag.innerHTML = html; tag.setAttribute('aria-label', 'De ' + de + ' por ' + reais(preco) + (preco === precoOferta ? ' na oferta 11.11' : ' levando 2')); }
        });
      });
    });
  }
  /* 31/10/2026: a janela de escolha do Leve junto (assets/cart-upsell.js) pergunta o preco da oferta pela mesma regra do card
     (0 = sem oferta) e conta as pecas da cor pela mesma leitura da troca: so a linha de 1 peca vira a copia */
  cfg.precoLeveJunto = function (h) {
    return colecao().then(function (s) { return precoOferta ? precoAoEntrar(h, s) : 0; });
  };
  cfg.pecas = pecas;
  /* o Leve junto se monta e troca o preco sozinho (lista nova, cor ou tamanho trocados): confere de novo no proximo quadro */
  var vigia = 0;
  new MutationObserver(function () {
    if (vigia) return;
    vigia = requestAnimationFrame(function () { vigia = 0; if (document.querySelector('cart-upsell-component .cart-upsell-product-card')) leveJunto(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* pagina de um sutia da oferta: original e copia ja ficam baixados antes do Adicionar */
  var naPagina = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (naPagina) colecao().then(function (s) { naPagina = decodeURIComponent(naPagina); if (s[naPagina]) { produto(naPagina); produto(copiaDe(naPagina)); if (copias2[naPagina]) produto(copias2[naPagina]); } });

  conferir();
})();
